<template>
  <div class="trend-chart-wrapper">
    <div class="controls">
      <el-select v-model="reportType" placeholder="选择分析类型" size="small" style="width: 140px;">
        <el-option label="年度分析" value="year" />
        <el-option label="月度分析" value="month" />
      </el-select>

      <el-date-picker
          v-if="reportType === 'year'"
          v-model="yearValue"
          type="year"
          placeholder="选择年份"
          size="small"
          style="margin-left: 12px; width: 120px;"
          :picker-options="yearPickerOptions"
          format="yyyy"
          value-format="yyyy"
          @change="handleTimeChange"
      />

      <el-date-picker
          v-if="reportType === 'month'"
          v-model="timeValue"
          type="month"
          placeholder="选择月份"
          size="small"
          style="margin-left: 12px; width: 140px;"
          :picker-options="monthPickerOptions"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="handleTimeChange"
      />

      <el-checkbox v-model="enableCompare" style="margin-left: 24px;" @change="handleCompareChange">启用对比</el-checkbox>

      <el-date-picker
          v-if="enableCompare && reportType === 'year'"
          v-model="compareYearValue"
          type="year"
          placeholder="选择对比年份"
          size="small"
          style="margin-left: 12px; width: 120px;"
          :picker-options="yearPickerOptions"
          format="yyyy"
          value-format="yyyy"
          @change="handleCompareTimeChange"
      />

      <el-date-picker
          v-if="enableCompare && reportType === 'month'"
          v-model="compareTimeValue"
          type="month"
          placeholder="选择对比月份"
          size="small"
          style="margin-left: 12px; width: 140px;"
          :picker-options="monthPickerOptions"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="handleCompareTimeChange"
      />

      <el-radio-group
          v-if="enableCompare"
          v-model="metricType"
          size="small"
          style="margin-left: 24px;"
      >
        <el-radio-button label="number">销量</el-radio-button>
        <el-radio-button label="amount">金额</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 不启用对比时的图表 -->
    <div
        v-show="!enableCompare"
        ref="chartNoCompare"
        class="chart-container"
    ></div>

    <!-- 启用对比时的图表 -->
    <div
        v-show="enableCompare"
        ref="chartCompare"
        class="chart-container"
    ></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'TrendChartSwitcher',
  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    var now = new Date()
    var currentYear = now.getFullYear()
    var currentMonth = currentYear + '-' + String(now.getMonth() + 1).padStart(2, '0')
    var lastYear = currentYear - 1

    return {
      reportType: 'year',
      yearValue: String(currentYear),
      timeValue: currentMonth,

      enableCompare: false,
      compareYearValue: String(lastYear),
      compareTimeValue: lastYear + '-' + String(now.getMonth() + 1).padStart(2, '0'),

      metricType: 'number', // 对比时选择指标

      mainData: [],
      compareData: [],

      loading: false,

      chartNoCompare: null,
      chartCompare: null,

      yearPickerOptions: {
        disabledDate: function(time) {
          return time.getFullYear() < 2024 || time.getFullYear() > (new Date()).getFullYear()
        }
      },
      monthPickerOptions: {
        disabledDate: function(time) {
          var minDate = new Date(2024, 0, 1)
          var maxDate = new Date()
          return time < minDate || time > maxDate
        }
      }
    }
  },
  watch: {
    productId: {
      immediate: true,
      handler: function() {
        this.resetTimes()
        this.fetchData()
      }
    },
    reportType: function() {
      this.resetTimes()
      this.fetchData()
    },
    enableCompare: function() {
      this.resetTimes()
      this.fetchData()
    },
    metricType: function() {
      if (this.enableCompare) {
        this.updateCompareChart()
      }
    }
  },
  mounted: function() {
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartNoCompare) {
      this.chartNoCompare.dispose()
      this.chartNoCompare = null
    }
    if (this.chartCompare) {
      this.chartCompare.dispose()
      this.chartCompare = null
    }
    this.resetAllData()
  },
  methods: {
    resetAllData() {
      var now = new Date()
      var currentYear = now.getFullYear()
      var currentMonth = currentYear + '-' + String(now.getMonth() + 1).padStart(2, '0')
      var lastYear = currentYear - 1

      this.reportType = 'year'
      this.yearValue = String(currentYear)
      this.timeValue = currentMonth
      this.enableCompare = false
      this.compareYearValue = String(lastYear)
      this.compareTimeValue = lastYear + '-' + String(now.getMonth() + 1).padStart(2, '0')
      this.metricType = 'number'
      this.mainData = []
      this.compareData = []
    },
    initCharts: function() {
      this.chartNoCompare = echarts.init(this.$refs.chartNoCompare)
      this.chartCompare = echarts.init(this.$refs.chartCompare)
      this.fetchData()
    },
    handleResize: function() {
      if (this.chartNoCompare) this.chartNoCompare.resize()
      if (this.chartCompare) this.chartCompare.resize()
    },
    resetTimes: function() {
      var now = new Date()
      var currentYear = now.getFullYear()
      var lastYear = currentYear - 1

      if (this.reportType === 'year') {
        this.yearValue = String(currentYear)
        this.compareYearValue = String(lastYear)
      } else {
        var currentMonth = currentYear + '-' + String(now.getMonth() + 1).padStart(2, '0')
        var lastYearMonth = lastYear + '-' + String(now.getMonth() + 1).padStart(2, '0')
        this.timeValue = currentMonth
        this.compareTimeValue = lastYearMonth
      }
    },
    handleTimeChange: function() {
      this.fetchData()
    },
    handleCompareTimeChange: function() {
      this.fetchData()
    },
    handleCompareChange: function() {
      if (this.enableCompare) {
        this.resetTimes()
      }
      this.fetchData()
    },
    fetchData: async function() {
      if (!this.productId) return

      var time = null
      var compareTime = null

      if (this.reportType === 'year') {
        time = this.yearValue
        compareTime = this.enableCompare ? this.compareYearValue : null
      } else {
        time = this.timeValue
        compareTime = this.enableCompare ? this.compareTimeValue : null
      }

      if (!time) {
        this.mainData = []
        this.compareData = []
        this.updateCharts()
        return
      }

      this.loading = true
      try {
        var mainRes = await this.$http.get('/alcohol-sales/product-trend', {
          params: {
            productId: this.productId,
            type: this.reportType,
            time: time,
          }
        })

        this.mainData = (mainRes.data.resultObj || []).map(function(item) {
          return {
            labels: item.labels,
            number: Number(item.number) || 0,
            amount: Number(item.amount) || 0
          }
        })

        if (this.enableCompare && compareTime) {
          var compareRes = await this.$http.get('/alcohol-sales/product-trend', {
            params: {
              productId: this.productId,
              type: this.reportType,
              time: compareTime
            }
          })
          this.compareData = (compareRes.data.resultObj || []).map(function(item) {
            return {
              labels: item.labels,
              number: Number(item.number) || 0,
              amount: Number(item.amount) || 0
            }
          })
        } else {
          this.compareData = []
        }

        this.updateCharts()
      } catch (e) {
        console.error('请求数据失败', e)
        this.mainData = []
        this.compareData = []
        this.updateCharts()
      } finally {
        this.loading = false
      }
    },
    updateCharts: function() {
      if (this.enableCompare) {
        this.updateCompareChart()
      } else {
        this.updateNoCompareChart()
      }
    },
    getFilteredXAxisLabels: function(dataLabels) {
      if (this.reportType === 'month') {
        return dataLabels.map((label, index) => {
          // 日度数据：显示第1天、中间几天和最后一天
          const showLabel = index === 0 ||
              index === dataLabels.length - 1 ||
              (dataLabels.length > 10 && index % Math.floor(dataLabels.length / 5) === 0)
          return showLabel ? label : ''
        })
      }
      return dataLabels.slice()
    },
    updateNoCompareChart: function() {
      if (!this.chartNoCompare) return

      var sortedData = this.mainData.slice().sort(function(a, b) {
        return Number(a.labels) - Number(b.labels)
      })

      var xData = sortedData.map(function(i) { return i.labels })
      var amountData = sortedData.map(function(i) { return i.amount })
      var numberData = sortedData.map(function(i) { return i.number })

      var maxAmount = Math.max.apply(null, amountData)
      var maxNumber = Math.max.apply(null, numberData)
      var maxAmountY = maxAmount * 1.2
      var maxNumberY = maxNumber * 1.2

      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#eee',
          borderWidth: 1,
          textStyle: { fontSize: 14, color: '#333' },
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            var tip = '<div style="font-weight:bold;margin-bottom:5px;color:#333;">' + params[0].axisValue + '</div>'
            for (var i = 0; i < params.length; i++) {
              var p = params[i]
              var val = p.value || 0
              var valText = p.seriesName === '金额' ? '¥' + val.toLocaleString() : val.toLocaleString() + ' 箱'
              tip += '<div style="display:flex;align-items:center;margin:3px 0;">' +
                  '<span style="width:10px;height:10px;border-radius:50%;background:' + p.color + ';margin-right:5px;"></span>' +
                  p.seriesName + ': ' + valText +
                  '</div>'
            }
            return tip
          }
        },
        legend: {
          data: ['金额', '销量'],
          top: 0,
          textStyle: { fontSize: 14, color: '#666' },
          itemGap: 24
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          boundaryGap: false,
          axisLabel: {
            interval: 0,  // 不间隔，全部显示
            fontSize: 12,
            color: '#666',
            rotate: 45,  // 45度旋转，避免重叠
          },
          axisLine: { lineStyle: { color: '#dcdfe6', width: 1 } },
          splitLine: { show: false }
        },
        yAxis: [
          {
            type: 'value',
            name: '金额 (元)',
            min: 0,
            max: maxAmountY,
            axisLabel: {
              fontSize: 12,
              color: '#409EFF',
              formatter: function(val) {
                return '¥' + val.toLocaleString()
              }
            },
            axisLine: { lineStyle: { color: '#409EFF', width: 1 } },
            splitLine: { lineStyle: { type: 'dashed', color: '#eee' } }
          },
          {
            type: 'value',
            name: '销量 (箱)',
            min: 0,
            max: maxNumberY,
            position: 'right',
            axisLabel: {
              fontSize: 12,
              color: '#67C23A'
            },
            axisLine: { lineStyle: { color: '#67C23A', width: 1 } },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '金额',
            type: 'line',
            yAxisIndex: 0,
            data: amountData,
            smooth: true,
            lineStyle: { width: 3, color: '#409EFF' },
            symbolSize: 6,
            itemStyle: { color: '#409EFF', borderColor: '#2b6cb0', borderWidth: 1 },
            label: {
              show: true,
              position: 'top',
              color: '#409EFF',
              fontSize: 12,
              formatter: function(params) {
                return params.value > 0 ? '¥' + params.value.toLocaleString() : ''
              }
            },
            emphasis: { itemStyle: { color: '#2b6cb0', borderColor: '#1a3f6b' } }
          },
          {
            name: '销量',
            type: 'line',
            yAxisIndex: 1,
            data: numberData,
            smooth: true,
            lineStyle: { width: 3, color: '#67C23A' },
            symbolSize: 6,
            itemStyle: { color: '#67C23A', borderColor: '#4a9121', borderWidth: 1 },
            label: {
              show: true,
              position: 'top',
              color: '#67C23A',
              fontSize: 12,
              formatter: function(params) {
                return params.value > 0 ? params.value.toLocaleString() + ' 箱' : ''
              }
            },
            emphasis: { itemStyle: { color: '#4a9121', borderColor: '#2d6814' } }
          }
        ]
      }

      this.chartNoCompare.setOption(option, true)
      this.chartNoCompare.resize()
    },


    updateCompareChart: function() {
      if (!this.chartCompare) return

      var metric = this.metricType

      var sortedMain = this.mainData.slice().sort(function(a,b) {
        return Number(a.labels) - Number(b.labels)
      })
      var sortedCompare = this.compareData.slice().sort(function(a,b) {
        return Number(a.labels) - Number(b.labels)
      })

      var xData = sortedMain.map(function(i) { return i.labels })
      var mainSeries = sortedMain.map(function(i) { return i[metric] })
      var compareSeries = sortedCompare.length ? sortedCompare.map(function(i) { return i[metric] }) : []

      var allVals = mainSeries.concat(compareSeries).filter(function(v){ return !isNaN(v) })
      var maxVal = allVals.length ? Math.max.apply(null, allVals) * 1.2 : 10

      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#eee',
          borderWidth: 1,
          textStyle: { fontSize: 14, color: '#333' },
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            var tip = '<div style="font-weight:bold;margin-bottom:5px;color:#333;">' + params[0].axisValue + '</div>'
            for (var i = 0; i < params.length; i++) {
              var p = params[i]
              var val = p.value || 0
              var valText = metric === 'amount' ? ('¥' + val.toLocaleString()) : val.toLocaleString() + ' 箱'
              tip += '<div style="display:flex;align-items:center;margin:3px 0;">' +
                  '<span style="width:10px;height:10px;border-radius:50%;background:' + p.color + ';margin-right:5px;"></span>' +
                  p.seriesName + ': ' + valText +
                  '</div>'
            }
            return tip
          }
        },
        legend: {
          data: [this.getCurrentTimeLabel(), this.getCompareTimeLabel()],
          top: 0,
          textStyle: { fontSize: 14, color: '#666' },
          itemGap: 24
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          boundaryGap: false,
          axisLabel: {
            interval: 0,  // 不间隔，全部显示
            fontSize: 12,
            color: '#666',
            rotate: 45,
          },
          axisLine: { lineStyle: { color: '#dcdfe6', width: 1 } },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          name: metric === 'number' ? '销量 (箱)' : '金额 (元)',
          min: 0,
          max: maxVal,
          axisLabel: {
            fontSize: 12,
            color: '#666',
            formatter: function(val) {
              return metric === 'amount' ? ('¥' + val.toLocaleString()) : val.toLocaleString() + ' 箱'
            }
          },
          axisLine: { lineStyle: { color: '#dcdfe6', width: 1 } },
          splitLine: { lineStyle: { type: 'dashed', color: '#eee' } }
        },
        series: [
          {
            name: this.getCurrentTimeLabel(),
            type: 'line',
            data: mainSeries,
            smooth: true,
            lineStyle: { width: 3, color: '#36a3f7' },
            symbolSize: 6,
            itemStyle: { color: '#36a3f7', borderColor: '#2c69d1', borderWidth: 1 },
            label: {
              show: true,
              position: 'top',
              color: '#36a3f7',
              fontSize: 12,
              formatter: function(params) {
                return params.value > 0 ? (metric === 'amount' ? ('¥' + params.value.toLocaleString()) : params.value.toLocaleString() + ' 箱') : ''
              }
            },
            emphasis: { itemStyle: { color: '#2c69d1', borderColor: '#1a4b9b' } }
          }
        ]
      }

      if (compareSeries.length) {
        option.series.push({
          name: this.getCompareTimeLabel(),
          type: 'line',
          data: compareSeries,
          smooth: true,
          lineStyle: { type: 'dashed', width: 3, color: '#67c23a' },
          symbolSize: 6,
          itemStyle: { color: '#67c23a', borderColor: '#4a9121', borderWidth: 1 },
          label: {
            show: true,
            position: 'top',
            color: '#67c23a',
            fontSize: 12,
            formatter: function(params) {
              return params.value > 0 ? (metric === 'amount' ? ('¥' + params.value.toLocaleString()) : params.value.toLocaleString() + ' 箱') : ''
            }
          },
          emphasis: { itemStyle: { color: '#4a9121', borderColor: '#2d6814' } }
        })
      }

      this.chartCompare.setOption(option, true)
      this.chartCompare.resize()
    },


    getCurrentTimeLabel: function() {
      if (this.reportType === 'year') {
        return this.yearValue + '年'
      } else {
        var arr = this.timeValue.split('-')
        return arr[0] + '年' + arr[1] + '月'
      }
    },
    getCompareTimeLabel: function() {
      if (this.reportType === 'year') {
        return this.compareYearValue + '年'
      } else {
        var arr = this.compareTimeValue.split('-')
        return arr[0] + '年' + arr[1] + '月'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.trend-chart-wrapper {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  user-select: none;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.controls {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.chart-container {
  flex: 1;
  width: 100%;
  min-height: 400px;
  position: relative;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// TrendChartSwitcher.vue?044fc486